import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import { Landing } from './components/landing-page';
import { NewTimerPage } from './components/new-timer';
import { JoinPage } from './components/join-page';
import { CreatePage } from './components/create-page';
import { SavePage } from './components/saved-page';
import { EditLap } from './components/edit-lap';

function App() { 

  return (
    <Router>
      <Switch>
        <Route path='/stopwatch/:session'>
          <NewTimerPage />
        </Route>
        <Route exact path='/join'>
          <JoinPage />
        </Route>
        <Route exact path='/create'>
          <CreatePage />
        </Route>
        <Route exact path='/saved'>
          <SavePage />
        </Route>
        <Route exact path='/test'>
          <EditLap runners={[{name: 'Jack', laps: [{time: 1242556, comment: 'Hello there'}], stopTime: 0}]} startTime={0} lap={{name: 'Jack', lap: 0}} submit={() => {}} close={() => {}} />
        </Route>
        <Route exact path='/'>
          <Landing />
        </Route>
      </Switch>
    </Router>
  )
}

export default App;
